// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2ZVyo","label":"Completed_label__39r-m"};